define([
	"dojo/_base/declare",
	"csi/html",
	"csi/locale",
	"csi/middleware/common",
	"csi/utility/stringUtility",
	"csi/xml",
	"csi/prefs/_base",
	"ProductSpec/SizeChart/CustomViewSizeChartOptions",
	"ProductSpec/SizeChart/SizeChartTableCustomViewOptionsStore",
	"ProductSpec/SizeChart/SizeChartTableOptionsTab",
	"SiteAdmin/DataSheetTable"
], function(declare, html, locale, {convertEnumToComponentItem}, {stringSubstitute}, xml, csiPrefs, {SizeChartDimensionFormatOptions, SizeChartDisplayOptions}, SizeChartTableCustomViewOptionsStore, SizeChartTableOptionsTab, DataSheetTable) {

	return declare(DataSheetTable, {
		allowSuspendInCustomViewPreview: true,
		customViewOptionsComponent: SizeChartTableOptionsTab,
		customViewOptionsStore: SizeChartTableCustomViewOptionsStore,

		// String: number format to use for displaying size chart numbers (default comes from ProductSpecAdmin.SCFormatAbsolute or SCFormatIncrement)
		//sizeChartDimensionFormat: null,

		// String: d to use for displaying size chart numbers (default comes from ProductSpecAdmin.SCGradingDefaultDisplay)
		//sizeChartDisplay: null,

		// String: units to use for displaying size chart numbers (default comes from ProductSpecAdmin.SCValueUnits)
		//sizeChartUnits: null,

		/**
		 * @override
		 * Display unit and increment settings in view footer
		 */
		_buildBody() {
			var params = [];

			if (this.sizeChartUnits) {
				params.push(csiPrefs.optionResource("SizeChartUnits"));
				params.push(locale.resource(this.sizeChartUnits));
			}

			if (this.sizeChartDisplay) {
				params.push(csiPrefs.optionResource("SizeChartDisplay"));
				params.push(locale.resource(this.sizeChartDisplay));
			}

			// The story requirement was that the table status bar should only contain
			// Compare: Shape or Compare: Increment, but if the custom view option is
			// set to None, do not display anything for compare in the status bar.
			if (this.sizeChartCompare && (xml.enumGetText(this.sizeChartCompare) != "None")) {
				params.push(csiPrefs.optionResource("sizeChartCompare"));
				params.push(locale.getEnumName(this.sizeChartCompare));
			}

			if (params.length) {
				var res = this._buildPlaceholderString(params);
				this.set("messageRight", stringSubstitute(res, params));
			}

			return this.inherited(arguments);
		},

		/**
		 * Build-up the string containing placeholders and tabs
		 * depending on the number of parameters.
		 *
		 * @param {Array} params - parameters whose count determines number of placeholders
		 * @returns {String} - string built-up with placeholders and tabs
		 */
		_buildPlaceholderString: function(params) {
			var cnt = params.length;
			var placeholderString = "";

			if (cnt === 2) {
				placeholderString = "${0}: ${1}";
			} else {
				for (var idx = 0; idx < cnt; idx = idx + 2) {
					placeholderString += "${" + idx + "}: ${" + (idx + 1) + "}";
					if (idx < cnt - 2) {
						placeholderString += html.TAB;
					}
				}
			}

			return placeholderString;
		},

		/**
		 * @override
		 * Return all the dropdown options for Size chart options section
		 */
		getCustomViewDropDownOptions() {
			const options = this.inherited(arguments);

			// Size chart increment display dropdown options
			const sizeChartIncrementDisplayOptions = convertEnumToComponentItem("Size Chart Display");

			// Size chart units dropdown options
			const sizeChartUnitsOptions = convertEnumToComponentItem("Size Chart Units");

			// Size chart compare dropdown options
			const sizeChartCompareOptions = convertEnumToComponentItem("Size Chart Compare");

			return {
				...options,
				sizeChartCompareOptions,
				sizeChartDimensionFormatOptions: SizeChartDimensionFormatOptions,
				sizeChartDisplayOptions: SizeChartDisplayOptions,
				sizeChartIncrementDisplayOptions,
				sizeChartUnitsOptions,
			};
		}
	});
});